<template>
  <div>
    <b-modal
      id="modal-updateStatus"
      ref="updateStatus"
      hide-footer
      centered
      title="Ajouter un attribut"
    >
      <div class="pl-lg-4">
        <div class="row">
          <div class="col-12">
            <div>
              <center>
                <b-form-input
                  type="text"
                  placeholder="Nom de l'attribut"
                  v-model="attributeName"
                ></b-form-input>
                <b-form-tags
                  placeholder="Ajouter des valeurs"
                  remove-on-delete
                  tag-pills
                  size="lg"
                  v-model="value"
                ></b-form-tags>
              </center>
            </div>
          </div>
        </div>
      </div>

      <hr class="my-4" />
      <center>
        <b-btn
          type="submit"
          style="background-color: #c2b59b; color: #fff"
          @click="addAttribute"
          >Ajouter</b-btn
        >
      </center>
    </b-modal>
    <GStockLoader :loading="loading" />
  </div>
</template>
<script>
import GStockLoader from "@/components/Loader";
import { put } from "@/mixins/api";
export default {
  name: "addattribute",
  components: {
    GStockLoader,
  },
  data() {
    return {
      loading: false,
      modalupd: false,
      model: {
        id: "",
        name: "",
        attributes: [],
      },
      attributeName: "",
      value: [],
    };
  },
  methods: {
    setId(id, name, attributes) {
      this.model.id = id;
      this.model.name = name;
      this.model.attributes = attributes;
      this.$refs.updateStatus.show();
    },
    addAttribute() {
      if (this.attributeName.length == 0) return;
      this.loading = true;
      if (this.value.length != 0)
        this.attributeName = this.attributeName + "~~" + this.value.join("~");
      const model = {
        id: this.model.id,
        name: this.model.name,
        attributes: [...this.model.attributes, this.attributeName].join(";"),
      };
      put("stp", model)
        .then((resp) => {
          this.$emit("updated");
          this.$refs.updateStatus.hide();
        })
        .finally(() => {
          this.loading = false;
        });

      this.modalupd = true;
    },
  },
  mounted() {},
};
</script>
<style>
#modal-updateStatus li {
  padding:5px !important;
  color: blue !important;
  font-size: 14px !important;
}
</style>      